module.exports = __webpack_public_path__ + "img/recognize.34670622.png";